import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVideo, faBook, faEdit, faTasks, faLock,
} from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as BookIcon } from './svg/bookIcon.svg';
import { ReactComponent as LockIcon } from './svg/lockIcon.svg';
import { ReactComponent as OtherIcon } from './svg/otherIcon.svg';
import { ReactComponent as ProblemIcon } from './svg/problemIcon.svg';
import { ReactComponent as VerticalIcon } from './svg/verticalIcon.svg';
import { ReactComponent as VideoIcon } from './svg/videoIcon.svg';

export default function UnitIcon({ type }) {
  let Icon = null;
  switch (type) {
    case 'video':
      Icon = VideoIcon;
      break;
    case 'other':
      Icon = BookIcon;
      break;
    case 'vertical':
      Icon = VerticalIcon;
      break;
    case 'problem':
      Icon = ProblemIcon;
      break;
    case 'lock':
      Icon = LockIcon;
      break;
    default:
      Icon = BookIcon;
  }

  return (
    // <FontAwesomeIcon className="unit-icon" icon={icon} />
    <Icon className="unit-icon" />
  );
}

UnitIcon.propTypes = {
  type: PropTypes.oneOf(['video', 'other', 'vertical', 'problem', 'lock']).isRequired,
};
